import SearchInputBottomSheet from 'components/SearchInput/SearchInputBottomSheet';
import GoToSignIn from 'components/park/detail/GoToSignIn';
import OpenTutorialButton from 'components/tutorial/OpenTutorialButton';
import useIsLoggedIn from 'hooks/useIsLoggedIn';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Keyboard } from 'react-native';
import { useMapStore } from 'stores/mapStore';
import { useSearchStore } from 'stores/searchStore';
import styled from 'styled-components/native';
import { ColumnWithMargins } from 'styles/ContainerStyles';
import { ParkZone } from 'types/generatedSchemaTypes';
import useDebounce from '../../hooks/useDebounce';
import ParkingZoneListRenderer from './ParkingZoneListRenderer';

const Wrapper = styled.Pressable<{ padding: boolean }>`
  padding: 0 ${({ padding }) => (padding ? '20px' : '0')};
  height: 100%;
  width: 100%;
  display: flex;
  flex: 1;
`;
const pressHandler = () => {
  Keyboard.dismiss();
};

export type ParkZoneWithVisibility = ParkZone & ParkZoneMemberGroup;

export type ParkZoneMemberGroup = {
  memberGroupName?: string;
};

const ParkingZoneSearch: React.FC<{
  withLTP?: boolean;
  isTesting?: boolean;
  padding?: boolean;
}> = ({ withLTP = false, isTesting = false, padding = true }) => {
  const filters = useMapStore((state) => state.mapFilters);
  const activeFilterCount = Object.values(filters).filter(
    (value) => value === true
  ).length;

  const { t } = useTranslation();
  const { searchTerm, searchInputActive, setSearchTerm } = useSearchStore(
    (state) => state
  );
  const debouncedSearchTerm = useDebounce(searchTerm, 300);
  const { isLoggedIn } = useIsLoggedIn();

  useEffect(() => {
    setSearchTerm(debouncedSearchTerm);
  }, [debouncedSearchTerm, setSearchTerm]);

  return (
    <Wrapper
      padding={padding}
      onPress={pressHandler}
      accessible={false}
      importantForAccessibility="no">
      <SearchInputBottomSheet
        placeholder={t('search.placeholder')}
        value={searchTerm}
        clearable={true}
        onChangeText={setSearchTerm}
        testID="park-search-input"
        isTesting={isTesting}
        accessibilityLabel={t('longTermParking.search')}
      />
      {!isLoggedIn && <GoToSignIn />}
      {isLoggedIn && <OpenTutorialButton />}
      <ParkingZoneListRenderer
        activeFilterCount={activeFilterCount}
        searchFocus={searchInputActive}
        debouncedSearchTerm={debouncedSearchTerm}
        withLTP={withLTP}
      />
      <ColumnWithMargins mb={20} />
    </Wrapper>
  );
};

export default ParkingZoneSearch;
